export default __webpack_public_path__ + "static/img-1-3904086d2249bdc4c449ce0d24c3ef75.png";